/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_oer_information_video_description_edition37 = /** @type {(inputs: {}) => string} */ () => {
	return `Edition`
};

const fr_oer_information_video_description_edition37 = /** @type {(inputs: {}) => string} */ () => {
	return `Édition`
};

const de_oer_information_video_description_edition37 = /** @type {(inputs: {}) => string} */ () => {
	return `Ausgabe`
};

const es_oer_information_video_description_edition37 = /** @type {(inputs: {}) => string} */ () => {
	return `Edición`
};

const it_oer_information_video_description_edition37 = /** @type {(inputs: {}) => string} */ () => {
	return `Edizione`
};

const ar_oer_information_video_description_edition37 = /** @type {(inputs: {}) => string} */ () => {
	return `طبعة`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const oer_information_video_description_edition37 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.oer_information_video_description_edition37(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("oer_information_video_description_edition37", locale)
	if (locale === "en") return en_oer_information_video_description_edition37(inputs)
	if (locale === "fr") return fr_oer_information_video_description_edition37(inputs)
	if (locale === "de") return de_oer_information_video_description_edition37(inputs)
	if (locale === "es") return es_oer_information_video_description_edition37(inputs)
	if (locale === "it") return it_oer_information_video_description_edition37(inputs)
	return ar_oer_information_video_description_edition37(inputs)
};
export { oer_information_video_description_edition37 as "OER_INFORMATION_VIDEO_DESCRIPTION_EDITION" }